<template>
  <div class="bg-dashboard screen-list">
    <v-sheet
      v-if="dataCustomer.length === 0"
      :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
      class="pa-3"
      style="margin-top: 70px"
    >
      <v-skeleton-loader
        class="mx-auto"
        max-width="auto"
        height="auto"
        type="list-item-avatar-three-line, divider, card-heading, image@3, article"
      />
    </v-sheet>

    <!-- header -->
    <div v-else>
      <div class="container-visit header">
        <div class="card-top">
          <div class="pb-6 d-flex justify-space-between align-center w-100">
            <div class="d-flex align-center">
              <img :src="data.customerPicture" class="picture-icon" />
              <div class="d-flex flex-column px-5">
                <span>{{ data.customerName }}</span>
                <div class="d-flex">
                  <base-icon-site
                    :data-type="data.typeName"
                    font-size="25"
                    icon-size="40"
                  />
                  <div class="px-4">
                    <base-icon-pin
                      :data-distance="data.distance"
                      font-size="25"
                      icon-size="40"
                    />
                  </div>
                </div>
                <u
                  class="cursor-pointer"
                  @click="toVisitDetailReadOnly(customerId, '0')"
                >
                  ดูรายละเอียดร้านค้า
                </u>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex flex-column align-end justify-center px-4">
                <span>แผนเข้าเยี่ยมเดือน :</span>
                <span>{{ data.month }}</span>
              </div>

              <div class="box-count">
                <h3 class="text-red-d">{{ data.count }}</h3>
                <span class="font-18">รายการ</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- plan date -->
      <div class="visit-plan">
        <div class="visit-plan-header">
          <span><b>วันที่เข้าเยี่ยม</b></span>
          <div class="d-flex" @click="toAddVisitPlan(customerId, '0')">
            <span class="text-red-d">เพิ่มแผนเข้าเยี่ยม</span>
            <div class="box-btnplus">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="currentColor"
                class="bi bi-plus-lg"
                viewBox="0 0 16 16"
                style="color: #ffffff"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="visit-plan-panel scroll-plan">
          <div
            class="visit-plan-card"
            v-for="(item, index) in data.list"
            :key="index"
          >
            <span>{{ item.date }}</span>
            <div class="d-flex">
              <btn-visit-plan
                :data="{ plan: item.plan_by, name: item.planby_name }"
              />
              <v-icon
                class="font-42 ml-6"
                @click="toVisitDetail(customerId, item.visit_id)"
              >
                icon-RIGHT
              </v-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },

  data() {
    return {
      customerId: this.$route.params.customerID,
      location: null,
      dataCustomer: [],
    }
  },

  computed: {
    data() {
      const result = {
        count: this.dataCustomer.count,
        month: this.dataCustomer.month,
        customerName: this.dataCustomer.customer_name,
        customerPicture: this.dataCustomer.customer_pic,
        typeName: this.dataCustomer.type,
        distance: this.dataCustomer.distance,
        list: this.dataCustomer.list,
      }

      return result
    },

    monthFormat() {
      // mockup...
      const date = new Date()
      var month = date.getMonth() + 1
      return month < 9 ? `0${month}` : month
    },
  },

  methods: {
    ...mapActions({
      getLocation: 'checkinout/getLocation_V2',
    }),

    toVisitDetailReadOnly(customerId, visitId) {
      this.$router.push({
        path: `/visitdetail/${customerId}/${visitId}`,
        query: { mode: 'readonly' },
      })
    },

    toVisitDetail(customerId, visitId) {
      this.$router.push({ path: `/visitdetail/${customerId}/${visitId}` })
    },

    toAddVisitPlan(customerId, visitId) {
      this.$router.push({ path: `/visitdetail/${customerId}/${visitId}` })
    },

    getVisitDetail() {
      const data = {
        method: 'POST',
        headers: this.setheaders,
        body: JSON.stringify({
          customer_id: this.customerId,
          lat_lng: this.location,
          month: this.monthFormat,
        }),
      }

      fetch(`${this.$baseAPI}/visit/customer_detail`, data)
        .then((response) => {
          return response.json()
        })
        .then((res) => {
          this.dataCustomer = res.items
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch('setTitle', 'เข้าเยี่ยม')

      this.getLocation().then((res) => {
        this.location = res
        this.getVisitDetail()
      })
    })

    // set background
    const wrap = document.querySelectorAll('.v-application--wrap')
    wrap[0].style.backgroundColor = '#eef3fa'
  },
}
</script>

<style lang="scss" scoped>
.visit-plan {
  margin: 20px;

  &-header {
    display: flex;
    justify-content: space-between;
    background-color: #eaeaea;
    padding: 25px 20px;
  }

  &-panel {
    background-color: #ffffff;
    padding: 25px 20px;
  }

  &-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0px;
    margin: 20px;
    border-bottom: 1px solid #e9e9e9;
  }
}

.scroll-plan {
  overflow-y: scroll;
  overflow-x: hidden;
  height: auto;
  max-height: 75vh;
}

.box-count {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow:
    rgb(60 64 67 / 30%) 0px 1px 2px 0px,
    rgb(60 64 67 / 15%) 0px 2px 6px 2px;
  color: #b82825;
  padding: 15px 25px;
  border-radius: 8px;
}

.box-btnplus {
  background-color: #b82825;
  width: 40px;
  display: flex;
  padding: 5px;
  justify-content: center;
  margin-left: 10px;
  align-items: center;
  border-radius: 5px;
}
</style>
